import React from 'react';
import { Link } from 'react-router-dom';
import CustomLink from '../CustomLink/CustomLink';

const Header = () => {
    return (
        <div className='sticky top-0 bg-red-500 px-12 py-8 flex justify-center md:justify-between'>
            <div className='hidden md:block text-2xl'>
                <Link to='/' className='font-sans font-bold text-white' > Roni Crypto</Link>

            </div>
            <div className='flex gap-4 text-xl'>

                <CustomLink to="/">Home</CustomLink>
                <CustomLink to='/coins'>Coins</CustomLink>
                <CustomLink to='/contact'>Contact</CustomLink>
                <CustomLink to='/about'>About</CustomLink>
            </div>

        </div >
    );
};
export default Header;